import { useState, useEffect } from "react";
import {
  Box, Typography, Button, TextField, Dialog, DialogTitle,
  DialogContent, DialogActions, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, IconButton,
  Grid, Autocomplete, Select, MenuItem, FormControl, InputLabel,
  Alert, Card, CardContent, Menu, MenuItem as MenuItemMui,
  Collapse, Pagination, Chip, Divider
} from "@mui/material";
import { 
  Add, Delete, Search, AttachMoney, MoreVert, 
  PictureAsPdf, Visibility, FilterList, Close, Store,
  Business, FilterAlt
} from "@mui/icons-material";
import { toast } from "react-toastify";
import { fournisseurService } from 'services/fournisseurService';
import { produitService } from 'services/produitService';
import api from '../../services/auth';
import pdfService from 'services/pdfService';

const AchatsFournisseurs = () => {
  const [achats, setAchats] = useState([]);
  const [fournisseurs, setFournisseurs] = useState([]);
  const [produits, setProduits] = useState([]);
  const [succursales, setSuccursales] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFournisseur, setSelectedFournisseur] = useState(null);
  const [selectedSuccursale, setSelectedSuccursale] = useState(null);
  const [dateAchat, setDateAchat] = useState("");
  const [notes, setNotes] = useState("");
  const [lignes, setLignes] = useState([{
    produit: null,
    produitNom: "",
    conditionnement: "",
    quantite: "",
    quantite_par_conditionnement: "",
    prix_achat_unitaire: "",
    prix_vente_unitaire: ""
  }]);
  const [totalAchat, setTotalAchat] = useState(0);
  const [suggestionsProduits, setSuggestionsProduits] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedAchat, setSelectedAchat] = useState(null);
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [fournisseurFilter, setFournisseurFilter] = useState(null);
  const [succursaleFilter, setSuccursaleFilter] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [activeFilterType, setActiveFilterType] = useState('all');
  
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalAchats, setTotalAchats] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const conditionnementOptions = [
    { value: "unite", label: "Unité" },
    { value: "caisse", label: "Caisse" },
    { value: "carton", label: "Carton" }
  ];

  const formatMontant = (montantString) => {
    const montant = parseFloat(montantString) || 0;
    return montant.toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setDateAchat(today);
  }, []);

  const fetchFournisseurs = async () => {
    try {
      const response = await fournisseurService.getAllFournisseurs();
      setFournisseurs(response.results || response.data || response);
    } catch (error) {
      console.error("Erreur chargement fournisseurs:", error);
      toast.error("Erreur lors du chargement des fournisseurs");
    }
  };

  const fetchProduits = async () => {
    try {
      const data = await produitService.getAllProduits();
      setProduits(data.results || data);
    } catch (error) {
      console.error("Erreur chargement produits:", error);
      toast.error("Erreur lors du chargement des produits");
    }
  };

  const fetchSuccursales = async () => {
    try {
      setLoading(true);
      const response = await api.get('/succursales/');
      
      let succursalesData = [];
      if (response.data) {
        if (Array.isArray(response.data)) {
          succursalesData = response.data;
        } else if (response.data.results) {
          succursalesData = response.data.results;
        } else if (response.data.data) {
          succursalesData = response.data.data;
        }
      }
      
      setSuccursales(succursalesData);
      
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      if (user.succursale_principale_id) {
        const succursalePrincipale = succursalesData.find(
          s => s.id === user.succursale_principale_id
        );
        if (succursalePrincipale) {
          setSelectedSuccursale(succursalePrincipale);
        }
      } else if (succursalesData.length === 1) {
        setSelectedSuccursale(succursalesData[0]);
      }
      
    } catch (error) {
      console.error("Erreur chargement succursales:", error);
      toast.error("Erreur lors du chargement des succursales");
    } finally {
      setLoading(false);
    }
  };

  const fetchAchats = async (pageNum = page, filters = {}) => {
    try {
      setLoading(true);
      
      const params = new URLSearchParams();
      params.append('page', pageNum);
      params.append('page_size', pageSize);
      
      if (filters.searchTerm && filters.searchTerm.trim()) {
        params.append('search', filters.searchTerm.trim());
      }
      if (filters.dateDebut && filters.dateDebut.trim()) {
        params.append('start_date', filters.dateDebut.trim());
      }
      if (filters.dateFin && filters.dateFin.trim()) {
        params.append('end_date', filters.dateFin.trim());
      }
      
      if (activeFilterType === 'fournisseur' && filters.fournisseurId) {
        params.append('fournisseur', filters.fournisseurId);
      } else if (activeFilterType === 'succursale' && filters.succursaleId) {
        params.append('succursale', filters.succursaleId);
      } else if (activeFilterType === 'all') {
        if (filters.fournisseurId) params.append('fournisseur', filters.fournisseurId);
        if (filters.succursaleId) params.append('succursale', filters.succursaleId);
      }
      
      const url = `https://sandbox.sgpme.biz/api/depot/achats/?${params.toString()}`;
      
      const response = await fetch(url, {
        headers: { 
          Authorization: `Bearer ${localStorage.getItem("access_token")}` 
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      let achatsData = [];
      let totalCount = 0;
      
      if (Array.isArray(data)) {
        achatsData = data;
        totalCount = data.length;
        setTotalPages(1);
      } else if (data.results) {
        achatsData = data.results;
        totalCount = data.count || 0;
        setTotalPages(Math.ceil(totalCount / pageSize) || 1);
      } else {
        achatsData = data;
        totalCount = data.length || 0;
        setTotalPages(1);
      }
      
      setAchats(achatsData);
      setTotalAchats(totalCount);
      
    } catch (error) {
      console.error("Erreur chargement achats:", error);
      toast.error("Erreur lors du chargement des achats");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFournisseurs();
    fetchProduits();
    fetchSuccursales();
    fetchAchats();
  }, []);

  useEffect(() => {
    const filters = {
      searchTerm,
      dateDebut,
      dateFin,
      fournisseurId: fournisseurFilter?.id,
      succursaleId: succursaleFilter?.id
    };
    
    setPage(1);
    
    const timer = setTimeout(() => {
      fetchAchats(1, filters);
    }, 500);
    
    return () => clearTimeout(timer);
  }, [searchTerm, dateDebut, dateFin, fournisseurFilter, succursaleFilter, activeFilterType]);

  useEffect(() => {
    const filters = {
      searchTerm,
      dateDebut,
      dateFin,
      fournisseurId: fournisseurFilter?.id,
      succursaleId: succursaleFilter?.id
    };
    
    fetchAchats(page, filters);
  }, [page]);

  const handleSearchProduits = async (searchTerm) => {
    if (searchTerm.length < 2) {
      setSuggestionsProduits([]);
      return;
    }
    
    try {
      const data = await produitService.searchProduits(searchTerm);
      setSuggestionsProduits(data.results || data);
    } catch (error) {
      console.error("Erreur recherche produits:", error);
    }
  };

  useEffect(() => {
    const total = lignes.reduce((sum, ligne) => {
      const qte = parseFloat(ligne.quantite) || 0;
      const qteParCond = parseFloat(ligne.quantite_par_conditionnement) || 0;
      const prix = parseFloat(ligne.prix_achat_unitaire) || 0;
      const quantiteTotale = qte * qteParCond;
      return sum + (quantiteTotale * prix);
    }, 0);
    setTotalAchat(total);
  }, [lignes]);

  const handleAddLigne = () => {
    setLignes([...lignes, {
      produit: null,
      produitNom: "",
      conditionnement: "",
      quantite: "",
      quantite_par_conditionnement: "",
      prix_achat_unitaire: "",
      prix_vente_unitaire: ""
    }]);
  };

  const handleRemoveLigne = (index) => {
    if (lignes.length > 1) {
      const newLignes = [...lignes];
      newLignes.splice(index, 1);
      setLignes(newLignes);
    }
  };

  const handleLigneChange = (index, field, value) => {
    const newLignes = [...lignes];
    newLignes[index][field] = value;
    
    if (field === 'produitNom' && value) {
      const produitTrouve = produits.find(p => 
        p.nom && p.nom.toLowerCase() === value.toLowerCase().trim()
      );
      
      if (produitTrouve) {
        newLignes[index].produit = produitTrouve.id;
        newLignes[index].conditionnement = produitTrouve.conditionnement || "";
        newLignes[index].quantite_par_conditionnement = produitTrouve.quantite_par_conditionnement || "";
      } else {
        newLignes[index].produit = null;
      }
    }
    
    setLignes(newLignes);
  };

  const handleMenuOpen = (event, achat) => {
    setAnchorEl(event.currentTarget);
    setSelectedAchat(achat);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleViewDetails = () => {
    setDetailDialogOpen(true);
    handleMenuClose();
  };

  const downloadAchatPDF = async (achat) => {
    try {
      if (!achat || !achat.id) {
        toast.error("Achat invalide");
        return;
      }

      setLoading(true);
      
      let achatComplet = achat;
      if (!achat.lignes || achat.lignes.length === 0 || !achat.fournisseur_detail) {
        const response = await api.get(`/depot/achats/${achat.id}/`);
        achatComplet = response.data;
      }

      await pdfService.generateAchatPDF(achatComplet);
      
      toast.success("PDF généré avec succès !");
    } catch (error) {
      console.error("Erreur génération PDF:", error);
      toast.error("Erreur lors de la génération du PDF");
    } finally {
      setLoading(false);
    }
  };

  const downloadRapportPDF = async () => {
    try {
      setLoading(true);
      
      const params = new URLSearchParams();
      params.append('page_size', '1000');
      
      if (dateDebut) params.append('start_date', dateDebut);
      if (dateFin) params.append('end_date', dateFin);
      if (searchTerm) params.append('search', searchTerm);
      
      if (activeFilterType === 'fournisseur' && fournisseurFilter) {
        params.append('fournisseur', fournisseurFilter.id);
      } else if (activeFilterType === 'succursale' && succursaleFilter) {
        params.append('succursale', succursaleFilter.id);
      } else {
        if (fournisseurFilter) params.append('fournisseur', fournisseurFilter.id);
        if (succursaleFilter) params.append('succursale', succursaleFilter.id);
      }
      
      const url = `https://sandbox.sgpme.biz/api/depot/achats/?${params.toString()}`;
      
      const response = await fetch(url, {
        headers: { 
          Authorization: `Bearer ${localStorage.getItem("access_token")}` 
        }
      });
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      let achatsData = [];
      if (Array.isArray(data)) {
        achatsData = data;
      } else if (data.results) {
        achatsData = data.results;
      } else {
        achatsData = data;
      }
      
      if (achatsData.length === 0) {
        toast.warning("Aucun achat à exporter avec ces filtres");
        return;
      }
      
      const filtresPDF = {
        dateDebut,
        dateFin,
        searchTerm,
        fournisseurNom: fournisseurFilter?.nom,
        succursaleNom: succursaleFilter?.nom,
        typeFiltre: activeFilterType
      };
      
      const montantTotal = achatsData.reduce((sum, achat) => 
        sum + parseFloat(achat.montant_total || 0), 0
      );
      
      const statistiques = {
        totalAchats: achatsData.length,
        montantTotal: montantTotal,
        moyenneAchat: montantTotal / (achatsData.length || 1),
        totalProduits: achatsData.reduce((sum, achat) => 
          sum + (achat.lignes?.length || 0), 0
        ),
        nbFournisseurs: new Set(achatsData.map(a => a.fournisseur)).size
      };
      
      await pdfService.generateRapportPDF(achatsData, filtresPDF, statistiques);
      
      toast.success("Rapport PDF généré avec succès !");
    } catch (error) {
      console.error("Erreur génération rapport PDF:", error);
      toast.error("Erreur lors de la génération du rapport PDF");
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setDateDebut("");
    setDateFin("");
    setFournisseurFilter(null);
    setSuccursaleFilter(null);
    setSearchTerm("");
    setActiveFilterType('all');
    setPage(1);
  };

  const handleCreateQuickProduit = async (index) => {
    const ligne = lignes[index];
    
    if (!ligne.produitNom.trim()) {
      toast.error("Veuillez d'abord saisir un nom de produit");
      return;
    }
    
    if (!ligne.conditionnement) {
      toast.error("Veuillez sélectionner un conditionnement");
      return;
    }
    
    try {
      const produitData = {
        nom: ligne.produitNom,
        conditionnement: ligne.conditionnement,
        quantite_par_conditionnement: parseFloat(ligne.quantite_par_conditionnement) || 1,
        prix_achat: parseFloat(ligne.prix_achat_unitaire) || 0,
        prix_vente: parseFloat(ligne.prix_vente_unitaire) || 0,
        stock_initial: 0,
        seuil_alerte: 10,
        est_actif: true,
      };
      
      const produitCree = await produitService.createProduit(produitData);
      
      const newLignes = [...lignes];
      newLignes[index].produit = produitCree.id;
      setLignes(newLignes);
      
      toast.success(`Produit "${ligne.produitNom}" créé avec succès !`);
      fetchProduits();
      
    } catch (error) {
      console.error("Erreur création produit:", error);
      toast.error("Erreur lors de la création du produit");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedFournisseur) {
      toast.error("Veuillez sélectionner un fournisseur");
      return;
    }
    
    if (!selectedSuccursale) {
      toast.error("Veuillez sélectionner une succursale");
      return;
    }
    
    if (!dateAchat) {
      toast.error("Veuillez sélectionner une date");
      return;
    }
    
    const hasInvalidLines = lignes.some(l => {
      return !l.produitNom.trim() ||
             !l.conditionnement ||
             !l.quantite || parseFloat(l.quantite) <= 0 ||
             !l.quantite_par_conditionnement || parseFloat(l.quantite_par_conditionnement) <= 0 ||
             !l.prix_achat_unitaire || parseFloat(l.prix_achat_unitaire) < 0 ||
             !l.prix_vente_unitaire || parseFloat(l.prix_vente_unitaire) < 0;
    });
    
    if (hasInvalidLines) {
      toast.error("Veuillez remplir correctement tous les champs des produits");
      return;
    }

    try {
      const lignesAvecProduits = await Promise.all(
        lignes.map(async (ligne) => {
          let produitId = ligne.produit;
          let produitExistant = false;
          
          if (!produitId) {
            try {
              const produitData = {
                nom: ligne.produitNom,
                conditionnement: ligne.conditionnement,
                quantite_par_conditionnement: parseFloat(ligne.quantite_par_conditionnement),
                prix_achat: parseFloat(ligne.prix_achat_unitaire),
                prix_vente: parseFloat(ligne.prix_vente_unitaire),
                stock_initial: 0,
                seuil_alerte: 10,
                est_actif: true,
              };
              
              const produitCree = await produitService.createProduit(produitData);
              produitId = produitCree.id;
              toast.success(`Produit "${ligne.produitNom}" créé`);
            } catch (error) {
              console.error("Erreur création produit:", error);
              throw new Error(`Impossible de créer le produit "${ligne.produitNom}"`);
            }
          } else {
            produitExistant = true;
          }
          
          if (produitExistant && produitId) {
            try {
              await produitService.updateProduit(produitId, {
                prix_achat: parseFloat(ligne.prix_achat_unitaire),
                prix_vente: parseFloat(ligne.prix_vente_unitaire)
              });
            } catch (error) {
              console.warn(`Impossible de mettre à jour le produit ${produitId}:`, error);
            }
          }
          
          return {
            produit: Number(produitId),
            quantite: parseFloat(ligne.quantite),
            quantite_par_conditionnement: parseFloat(ligne.quantite_par_conditionnement),
            prix_achat_unitaire: parseFloat(ligne.prix_achat_unitaire),
            prix_vente_unitaire: parseFloat(ligne.prix_vente_unitaire),
          };
        })
      );

      const hasInvalidIds = lignesAvecProduits.some(l => isNaN(l.produit) || l.produit <= 0);
      if (hasInvalidIds) {
        throw new Error("Certains produits n'ont pas d'ID valide");
      }

      const dataToSend = {
        fournisseur: selectedFournisseur.id,
        succursale: selectedSuccursale.id,
        date_achat: dateAchat,
        notes: notes.trim() || null,
        lignes: lignesAvecProduits
      };

      const response = await fetch("https://sandbox.sgpme.biz/api/depot/achats/", {
        method: 'POST',
        headers: { 
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Erreur backend:", errorData);
        
        let errorMessage = "Erreur lors de l'enregistrement de l'achat";
        if (errorData.succursale) {
          errorMessage = errorData.succursale[0];
        } else if (errorData.lignes) {
          errorMessage = errorData.lignes[0]?.produit?.[0] || 
                        errorData.lignes[0]?.quantite_par_conditionnement?.[0] ||
                        JSON.stringify(errorData.lignes);
        } else if (errorData.detail) {
          errorMessage = errorData.detail;
        }
        
        throw new Error(errorMessage);
      }

      const achatCree = await response.json();
      
      for (const ligne of lignesAvecProduits) {
        try {
          const quantiteTotale = ligne.quantite * ligne.quantite_par_conditionnement;
          
          await produitService.ajusterStock(
            ligne.produit,
            quantiteTotale,
            'entree',
            `Achat N°${achatCree.numero || achatCree.id} - ${selectedSuccursale.nom}`
          );
        } catch (error) {
          console.error(`Erreur mise à jour stock produit ${ligne.produit}:`, error);
          toast.warning(`Le stock n'a pas pu être mis à jour pour un produit`);
        }
      }

      toast.success("Achat enregistré avec succès !");
      setOpenDialog(false);
      
      await Promise.all([
        fetchAchats(page),
        fetchProduits()
      ]);
      
      setSelectedFournisseur(null);
      setSelectedSuccursale(null);
      setDateAchat(new Date().toISOString().split('T')[0]);
      setNotes("");
      setLignes([{
        produit: null,
        produitNom: "",
        conditionnement: "",
        quantite: "",
        quantite_par_conditionnement: "",
        prix_achat_unitaire: "",
        prix_vente_unitaire: ""
      }]);
      
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      if (user.succursale_principale_id && succursales.length > 0) {
        const succursalePrincipale = succursales.find(s => s.id === user.succursale_principale_id);
        if (succursalePrincipale) {
          setSelectedSuccursale(succursalePrincipale);
        }
      } else if (succursales.length === 1) {
        setSelectedSuccursale(succursales[0]);
      }
      
    } catch (error) {
      console.error("Erreur complète:", error);
      toast.error(error.message || "Une erreur est survenue lors de l'enregistrement");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR');
    } catch (error) {
      return dateString;
    }
  };

  const calculateLigneTotal = (ligne) => {
    const qte = parseFloat(ligne.quantite) || 0;
    const qteParCond = parseFloat(ligne.quantite_par_conditionnement) || 0;
    const prix = parseFloat(ligne.prix_achat_unitaire) || 0;
    return (qte * qteParCond * prix).toLocaleString('fr-FR', { 
      minimumFractionDigits: 2,
      maximumFractionDigits: 2 
    });
  };

  const getFournisseurFilterName = () => {
    if (!fournisseurFilter) return "";
    return fournisseurs.find(f => f.id === fournisseurFilter.id)?.nom || "";
  };

  const getSuccursaleFilterName = () => {
    if (!succursaleFilter) return "";
    return succursales.find(s => s.id === succursaleFilter.id)?.nom || "";
  };

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">Achats Fournisseurs</Typography>
        <Box display="flex" gap={2} alignItems="center">
          <Button
            variant="outlined"
            startIcon={<FilterList />}
            onClick={() => setShowFilters(!showFilters)}
            color={showFilters ? "primary" : "inherit"}
          >
            Filtres
          </Button>
          <TextField
            placeholder="Rechercher..."
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 250 }}
            InputProps={{
              startAdornment: <Search sx={{ mr: 1, color: 'action.active' }} />,
            }}
          />
          <Button
            variant="contained"
            color="secondary"
            startIcon={<PictureAsPdf />}
            onClick={downloadRapportPDF}
            disabled={loading}
          >
            Rapport PDF
          </Button>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => setOpenDialog(true)}
          >
            Nouvel Achat
          </Button>
        </Box>
      </Box>

      {/* Filtres - Collapse */}
      <Collapse in={showFilters}>
        <Paper sx={{ p: 3, mb: 3, bgcolor: 'background.default' }}>
          <Typography variant="subtitle1" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
            <FilterAlt sx={{ mr: 1 }} /> Options de filtrage
          </Typography>
          
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                label="Date début"
                type="date"
                value={dateDebut}
                onChange={(e) => setDateDebut(e.target.value)}
                InputLabelProps={{ shrink: true }}
                size="small"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                label="Date fin"
                type="date"
                value={dateFin}
                onChange={(e) => setDateFin(e.target.value)}
                InputLabelProps={{ shrink: true }}
                size="small"
              />
            </Grid>
            
            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Type de filtre</InputLabel>
                <Select
                  value={activeFilterType}
                  onChange={(e) => setActiveFilterType(e.target.value)}
                  label="Type de filtre"
                >
                  <MenuItem value="all">Tous les filtres</MenuItem>
                  <MenuItem value="fournisseur">Uniquement fournisseur</MenuItem>
                  <MenuItem value="succursale">Uniquement succursale</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={12} md={2.5}>
              <Autocomplete
                options={fournisseurs}
                getOptionLabel={(option) => option.nom || ''}
                value={fournisseurFilter}
                onChange={(e, newValue) => setFournisseurFilter(newValue)}
                size="small"
                disabled={activeFilterType === 'succursale'}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    label={activeFilterType === 'fournisseur' ? "Fournisseur *" : "Filtrer par fournisseur"}
                    placeholder={activeFilterType === 'fournisseur' ? "Sélectionnez un fournisseur" : ""}
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props}>
                    <Box display="flex" alignItems="center">
                      <Business fontSize="small" sx={{ mr: 1, color: 'action.active' }} />
                      {option.nom}
                    </Box>
                  </li>
                )}
              />
            </Grid>
            
            <Grid item xs={12} md={2.5}>
              <Autocomplete
                options={succursales}
                getOptionLabel={(option) => option.nom || ''}
                value={succursaleFilter}
                onChange={(e, newValue) => setSuccursaleFilter(newValue)}
                size="small"
                disabled={activeFilterType === 'fournisseur'}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    label={activeFilterType === 'succursale' ? "Succursale *" : "Filtrer par succursale"}
                    placeholder={activeFilterType === 'succursale' ? "Sélectionnez une succursale" : ""}
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props}>
                    <Box display="flex" alignItems="center">
                      <Store fontSize="small" sx={{ mr: 1, color: 'action.active' }} />
                      {option.nom}
                    </Box>
                  </li>
                )}
              />
            </Grid>
            
            <Grid item xs={12} md={1}>
              <Button
                fullWidth
                variant="outlined"
                color="error"
                onClick={resetFilters}
                startIcon={<Close />}
                sx={{ height: 40 }}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
          
          {(dateDebut || dateFin || fournisseurFilter || succursaleFilter) && (
            <Box mt={2} p={1} bgcolor="action.hover" borderRadius={1}>
              <Typography variant="body2" color="textSecondary">
                <strong>Filtres actifs:</strong>
                {dateDebut && ` Du ${formatDate(dateDebut)}`}
                {dateFin && ` au ${formatDate(dateFin)}`}
                {fournisseurFilter && ` | Fournisseur: ${getFournisseurFilterName()}`}
                {succursaleFilter && ` | Succursale: ${getSuccursaleFilterName()}`}
                {activeFilterType !== 'all' && ` | Mode: ${activeFilterType === 'fournisseur' ? 'Uniquement fournisseur' : 'Uniquement succursale'}`}
              </Typography>
            </Box>
          )}
        </Paper>
      </Collapse>

      {/* Statistiques */}
      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom variant="body2">
                Achats
              </Typography>
              <Typography variant="h5">
                {totalAchats}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom variant="body2">
                Fournisseurs
              </Typography>
              <Typography variant="h5">
                {fournisseurs.length}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom variant="body2">
                Produits
              </Typography>
              <Typography variant="h5">
                {produits.length}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary" gutterBottom variant="body2">
                Succursales
              </Typography>
              <Typography variant="h5">
                {succursales.length}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Liste des achats */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Numéro</TableCell>
              <TableCell>Fournisseur</TableCell>
              <TableCell>Succursale</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Produits</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Utilisateur</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={8} align="center">Chargement...</TableCell>
              </TableRow>
            ) : achats.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  Aucun achat trouvé
                  {(dateDebut || dateFin || fournisseurFilter || succursaleFilter || searchTerm) && 
                    " avec les filtres appliqués"}
                </TableCell>
              </TableRow>
            ) : (
              achats.map((achat) => (
                <TableRow key={achat.id} hover>
                  <TableCell>
                    <Chip 
                      label={achat.numero || achat.id} 
                      size="small" 
                      color="primary" 
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell>{achat.fournisseur_detail?.nom || achat.fournisseur_nom || 'N/A'}</TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center">
                      <Store fontSize="small" sx={{ mr: 1, color: 'action.active' }} />
                      {achat.succursale_nom || achat.succursale?.nom || "N/A"}
                    </Box>
                  </TableCell>
                  <TableCell>{formatDate(achat.date_achat)}</TableCell>
                  <TableCell>
                    {achat.lignes?.length || 0} produit(s)
                  </TableCell>
                  <TableCell>
                    {formatMontant(achat.montant_total)} HTG
                  </TableCell>
                  <TableCell>{achat.utilisateur_detail?.username || achat.utilisateur_username || 'N/A'}</TableCell>
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      onClick={(e) => handleMenuOpen(e, achat)}
                      disabled={loading}
                    >
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {totalPages > 1 && (
        <Box display="flex" justifyContent="center" mt={3}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
            showFirstButton
            showLastButton
          />
        </Box>
      )}

      {/* Menu pour les actions */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItemMui onClick={handleViewDetails}>
          <Visibility fontSize="small" sx={{ mr: 2 }} />
          Voir les détails
        </MenuItemMui>
        <MenuItemMui onClick={() => {
          downloadAchatPDF(selectedAchat);
          handleMenuClose();
        }}>
          <PictureAsPdf fontSize="small" sx={{ mr: 2 }} />
          Télécharger PDF
        </MenuItemMui>
      </Menu>

      {/* Dialog de détail d'achat */}
      <Dialog 
        open={detailDialogOpen} 
        onClose={() => setDetailDialogOpen(false)} 
        maxWidth="md" 
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">
              Détails de l'achat N°{selectedAchat?.numero || selectedAchat?.id}
            </Typography>
            <Button
              variant="outlined"
              startIcon={<PictureAsPdf />}
              onClick={() => {
                downloadAchatPDF(selectedAchat);
                setDetailDialogOpen(false);
              }}
              size="small"
              disabled={loading}
            >
              Télécharger PDF
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {selectedAchat && (
            <>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Fournisseur</Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>{selectedAchat.fournisseur_detail?.nom || selectedAchat.fournisseur_nom || 'N/A'}</strong>
                  </Typography>
                  {selectedAchat.fournisseur_detail?.telephone && (
                    <Typography variant="body2">
                      Tél: {selectedAchat.fournisseur_detail.telephone}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Succursale</Typography>
                  <Typography variant="body1" gutterBottom>
                    <Box display="flex" alignItems="center">
                      <Store fontSize="small" sx={{ mr: 1, color: 'action.active' }} />
                      <strong>{selectedAchat.succursale_nom || selectedAchat.succursale?.nom || "N/A"}</strong>
                    </Box>
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Date</Typography>
                  <Typography variant="body1" gutterBottom>
                    {formatDate(selectedAchat.date_achat)}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Utilisateur</Typography>
                  <Typography variant="body1" gutterBottom>
                    {selectedAchat.utilisateur_detail?.username || selectedAchat.utilisateur_username || 'N/A'}
                  </Typography>
                </Grid>
                {selectedAchat.notes && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="textSecondary">Notes</Typography>
                    <Typography variant="body1" gutterBottom>
                      {selectedAchat.notes}
                    </Typography>
                  </Grid>
                )}
              </Grid>

              <Divider sx={{ my: 2 }} />

              <Typography variant="h6" gutterBottom>Produits achetés</Typography>
              
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Produit</TableCell>
                    <TableCell align="center">Conditionnement</TableCell>
                    <TableCell align="center">Qté</TableCell>
                    <TableCell align="center">Qté/Unité</TableCell>
                    <TableCell align="center">Total Unités</TableCell>
                    <TableCell align="right">Prix Achat</TableCell>
                    <TableCell align="right">Prix Vente</TableCell>
                    <TableCell align="right">Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedAchat.lignes?.map((ligne, index) => (
                    <TableRow key={index}>
                      <TableCell>{ligne.produit_detail?.nom || ligne.produit_nom || 'N/A'}</TableCell>
                      <TableCell align="center">{ligne.conditionnement}</TableCell>
                      <TableCell align="center">{parseFloat(ligne.quantite).toFixed(2)}</TableCell>
                      <TableCell align="center">{ligne.quantite_par_conditionnement}</TableCell>
                      <TableCell align="center">
                        {ligne.quantite_totale || (parseFloat(ligne.quantite) * ligne.quantite_par_conditionnement).toFixed(2)}
                      </TableCell>
                      <TableCell align="right">
                        {formatMontant(ligne.prix_achat_unitaire)} HTG
                      </TableCell>
                      <TableCell align="right">
                        {formatMontant(ligne.prix_vente_unitaire)} HTG
                      </TableCell>
                      <TableCell align="right">
                        {formatMontant(ligne.total || (parseFloat(ligne.quantite) * ligne.quantite_par_conditionnement * parseFloat(ligne.prix_achat_unitaire)))} HTG
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell colSpan={7} align="right">
                      <Typography variant="subtitle1" fontWeight="bold">
                        Total :
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="h6" color="primary">
                        {formatMontant(selectedAchat.montant_total)} HTG
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDetailDialogOpen(false)}>Fermer</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog pour nouveau achat */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <Store sx={{ mr: 1 }} />
            Nouvel Achat Fournisseur
          </Box>
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Grid container spacing={3}>
              {/* Sélection du fournisseur */}
              <Grid item xs={12} md={6}>
                <Autocomplete
                  options={fournisseurs}
                  getOptionLabel={(option) => option.nom || ''}
                  value={selectedFournisseur}
                  onChange={(e, newValue) => setSelectedFournisseur(newValue)}
                  renderInput={(params) => (
                    <TextField 
                      {...params} 
                      label="Sélectionnez un fournisseur *" 
                      required 
                      fullWidth
                    />
                  )}
                />
              </Grid>

              {/* Sélection de la succursale */}
              <Grid item xs={12} md={6}>
                <Autocomplete
                  options={succursales}
                  getOptionLabel={(option) => option.nom || ''}
                  value={selectedSuccursale}
                  onChange={(e, newValue) => setSelectedSuccursale(newValue)}
                  loading={loading}
                  renderInput={(params) => (
                    <TextField 
                      {...params} 
                      label="Succursale de destination *" 
                      required
                      placeholder="Choisir la succursale"
                      fullWidth
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props}>
                      <Box display="flex" alignItems="center">
                        <Store fontSize="small" sx={{ mr: 1, color: 'action.active' }} />
                        <Box>
                          <Typography variant="body1">{option.nom}</Typography>
                          {option.code && (
                            <Typography variant="caption" color="textSecondary">
                              Code: {option.code}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </li>
                  )}
                />
                <Typography variant="caption" color="textSecondary">
                  Le stock sera ajouté à cette succursale
                </Typography>
              </Grid>

              {/* Date d'achat */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Date d'achat *"
                  type="date"
                  value={dateAchat}
                  onChange={(e) => setDateAchat(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  required
                />
              </Grid>

              {/* Notes */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Notes (optionnel)"
                  multiline
                  rows={2}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="Informations supplémentaires sur cet achat..."
                />
              </Grid>

              {/* Lignes d'achat */}
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Produits achetés
                </Typography>
                
                {lignes.map((ligne, index) => (
                  <Box key={index} mb={3} p={2} border={1} borderColor="grey.300" borderRadius={1}>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', flexWrap: { xs: 'wrap', md: 'nowrap' } }}>

                      {/* Produit - flex 3 = ~35% */}
                      <Box sx={{ flex: 3, minWidth: { xs: '100%', md: 0 } }}>
                        <Autocomplete
                          freeSolo
                          options={produits}
                          getOptionLabel={(option) => {
                            if (typeof option === 'string') return option;
                            return option.nom || '';
                          }}
                          inputValue={ligne.produitNom}
                          onInputChange={(e, newValue) => {
                            handleLigneChange(index, 'produitNom', newValue);
                            if (newValue.length > 2) {
                              handleSearchProduits(newValue);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField 
                              {...params} 
                              label="Produit *" 
                              required
                              placeholder="Nom du produit"
                              fullWidth
                            />
                          )}
                          renderOption={(props, option) => (
                            <li {...props}>
                              <Box>
                                <Typography variant="body1">{option.nom}</Typography>
                              </Box>
                            </li>
                          )}
                        />
                        {ligne.produit === null && ligne.produitNom && (
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => handleCreateQuickProduit(index)}
                            sx={{ mt: 1 }}
                            fullWidth
                          >
                            Créer nouveau produit
                          </Button>
                        )}
                      </Box>
                      
                      {/* Conditionnement - flex 2 = ~23% */}
                      <Box sx={{ flex: 2, minWidth: { xs: 'calc(50% - 4px)', md: 0 } }}>
                        <FormControl fullWidth>
                          <InputLabel>Conditionnement *</InputLabel>
                          <Select
                            value={ligne.conditionnement || ""}
                            onChange={(e) => handleLigneChange(index, 'conditionnement', e.target.value)}
                            label="Conditionnement *"
                            required
                            fullWidth
                          >
                            <MenuItem value="">Sélectionner...</MenuItem>
                            {conditionnementOptions.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                      
                      {/* Quantité - flex 1 = ~10% */}
                      <Box sx={{ flex: 1, minWidth: { xs: 'calc(50% - 4px)', md: 0 } }}>
                        <TextField
                          fullWidth
                          label="Qté"
                          type="number"
                          value={ligne.quantite}
                          onChange={(e) => handleLigneChange(index, 'quantite', e.target.value)}
                          InputProps={{ inputProps: { min: 0, step: 0.01 } }}
                          placeholder="0"
                          required
                        />
                      </Box>
                      
                      {/* Quantité par conditionnement - flex 1 */}
                      <Box sx={{ flex: 1, minWidth: { xs: 'calc(50% - 4px)', md: 0 } }}>
                        <TextField
                          fullWidth
                          label="Qté/Unité"
                          type="number"
                          value={ligne.quantite_par_conditionnement}
                          onChange={(e) => handleLigneChange(index, 'quantite_par_conditionnement', e.target.value)}
                          InputProps={{ inputProps: { min: 0, step: 0.01 } }}
                          placeholder="0"
                          required
                        />
                      </Box>
                      
                      {/* Prix achat - flex 1.5 */}
                      <Box sx={{ flex: 1.5, minWidth: { xs: 'calc(50% - 4px)', md: 0 } }}>
                        <TextField
                          fullWidth
                          label="Prix achat"
                          type="number"
                          value={ligne.prix_achat_unitaire}
                          onChange={(e) => handleLigneChange(index, 'prix_achat_unitaire', e.target.value)}
                          InputProps={{ inputProps: { min: 0, step: 0.01 } }}
                          placeholder="0.00"
                          required
                        />
                      </Box>
                      
                      {/* Prix vente - flex 1.5 */}
                      <Box sx={{ flex: 1.5, minWidth: { xs: 'calc(50% - 4px)', md: 0 } }}>
                        <TextField
                          fullWidth
                          label="Prix vente"
                          type="number"
                          value={ligne.prix_vente_unitaire}
                          onChange={(e) => handleLigneChange(index, 'prix_vente_unitaire', e.target.value)}
                          InputProps={{ inputProps: { min: 0, step: 0.01 } }}
                          placeholder="0.00"
                          required
                        />
                      </Box>
                      
                      {/* Bouton supprimer */}
                      <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                        <IconButton 
                          onClick={() => handleRemoveLigne(index)}
                          disabled={lignes.length === 1}
                          color="error"
                        >
                          <Delete />
                        </IconButton>
                      </Box>
                    </Box>
                    
                    {/* Calcul de la ligne */}
                    {ligne.produitNom && ligne.quantite && ligne.quantite_par_conditionnement && ligne.prix_achat_unitaire && (
                      <Box mt={2} pt={1} borderTop={1} borderColor="grey.200">
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="textSecondary">
                              <strong>Total ligne:</strong> {calculateLigneTotal(ligne)} HTG
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Box display="flex" justifyContent="flex-end">
                              {ligne.produit && (
                                <Chip 
                                  label="Produit existant" 
                                  size="small" 
                                  color="success" 
                                  variant="outlined"
                                  sx={{ height: 24 }}
                                />
                              )}
                              {!ligne.produit && ligne.produitNom && (
                                <Chip 
                                  label="Nouveau produit" 
                                  size="small" 
                                  color="warning" 
                                  variant="outlined"
                                  sx={{ height: 24 }}
                                />
                              )}
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                  </Box>
                ))}
                
                <Button
                  startIcon={<Add />}
                  onClick={handleAddLigne}
                  variant="outlined"
                  sx={{ mt: 2 }}
                  fullWidth
                >
                  Ajouter une ligne de produit
                </Button>
              </Grid>

            </Grid>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => setOpenDialog(false)}>Annuler</Button>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary" 
              disabled={!selectedFournisseur || !selectedSuccursale || lignes.some(l => 
                !l.produitNom.trim() || 
                !l.conditionnement || 
                !l.quantite || 
                !l.quantite_par_conditionnement || 
                !l.prix_achat_unitaire || 
                !l.prix_vente_unitaire
              )}
              sx={{ ml: 2 }}
            >
              Enregistrer l'achat
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </Box>
  );
};

export default AchatsFournisseurs;
